import { Ammo } from "../items/ammo";
import { randomInt } from "../random";
import type { LootRule } from "./lootRule";

export class LootTable {
	private rules: LootRule[] = [];

	addRule(rule: LootRule): void {
		this.rules.push(rule);
	}

	getRules(): readonly LootRule[] {
		return this.rules;
	}

	getLoot(rewardLevel: number, rng: () => number = Math.random): Ammo | null {
		let sumOfAllShares = 0;
		const filtered: LootRule[] = [];

		for (const rule of this.rules) {
			if (!rule.isInRange(rewardLevel)) continue;
			filtered.push(rule);
			sumOfAllShares += rule.share;
		}

		if (filtered.length === 0) return null;

		const random = rng() * sumOfAllShares;
		let currentSum = 0;

		for (const rule of filtered) {
			currentSum += rule.share;
			if (random > currentSum) continue;
			return this.createLootFromRule(rule, rng);
		}

		return null;
	}

	private createLootFromRule(rule: LootRule, rng: () => number): Ammo {
		const amount = randomInt(rule.ammoMin, rule.ammoMax, rng);
		return new Ammo(rule.weaponKey, amount);
	}
}
